import { FuseChipSelect } from "@fuse";
import _ from "@lodash";
import { CircularProgress, Divider, FormControl, IconButton, Typography, withStyles } from "@material-ui/core";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import withReducer from "app/store/withReducer";
import clsx from "clsx";
import React from "react";
import { MdAdd, MdClose, MdSearch } from "react-icons/md";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import LookupDialog from "./LookupDialog";
import * as Actions from "./Store/Actions/LookupActions";
import LookupReducer from "./Store/Reducers/LookupReducer";

const styles = theme => ({
    root: {
        padding: "5px 4px",
        display: "flex",
        alignItems: "center",
        height: "57px",
        border: "1px solid " + theme.palette.divider,
    },
    input: {
        marginLeft: 8,
        flex: 1,
        minHeight: "4.6rem"
    },
    iconButton: {
        paddingLeft: 10,
    },
    divider: {
        width: 1,
        height: "85%",
        margin: 0,
    },
    layoutRoot: {},
    rootTheme: {
        color: theme.palette.text.primary,
        //    backgroundColor:  theme.palette.background.paper, //default
    },
    formControl: {
        margin: "0px 0",
        width: "100%",
        "&:last-child": {
            marginBottom: 0
        }
    },
    group: {},
    formGroupTitle: {
        position: "absolute",
        top: -10,
        left: 8,
        fontWeight: 600,
        padding: "0 4px",
        backgroundColor: theme.palette.type === "dark" ? "#424242" : "#FFF",
        fontSize: "12px",
    },
    formGroup: {
        position: "relative",
        // maxHeight: '58px',
        border: "1px solid " + theme.palette.divider,
        borderRadius: 2,
    },
    chip: {
        marginTop: "4px"
    },
    adornment: {
        padding: 0
    },
    chipSelect: {
        "& .fuse-chip-select__indicators": {
            display: "none"
        },
        "& div:before, div:after": {
            "border-bottom": "none !important",
        },
        "& span": {
            whiteSpace: "normal"
        },
        "& div": {
            height: "auto",
            minHeight: "32px"
        },
    },
});

class LookupApp extends XAPPComponent {

    state = {
        search: "",
        timer: null,
        loading: false,
    };

    componentDidMount() {
        const { autoSearch = false, selected = null } = this.props;
        if (autoSearch && (_.isNull(selected) || selected.length < 1)) {
            this.pesquisar();
            this.setLoading(true);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { filtrodescricao, autoSearch = false, selectFirstAuto = false, options, selected = null } = this.props;
        if (!this.state.loading && !_.isNull(this.state.search) && !_.isEqual(this.state.search, prevState.search) && this.state.search.length > 2) {
            clearTimeout(this.state.timer);
            let timer = setTimeout(() => {
                this.pesquisar({ "AND": [{ "campo": filtrodescricao, "operador": "LIKE", "valor": this.state.search.toUpperCase() }], "OR": [] });
            }, 1500);
            this.setState({ "loading": true, "timer": timer });
        }

        if (autoSearch && selectFirstAuto && (_.isNull(selected) || selected.length < 1) && !_.isNull(options) && options?.length === 1) {
            this.handleChangeLookup(options, { action: "select-option" });
        }

        if (this.state.loading && !prevState.loading) {
            setTimeout(() => {
                if (this.state.loading) {
                    this.setState({ "loading": false, "timer": null });
                }
            }, 15000);
        }
    }

    pesquisar = (_AConditions = null) => {
        const { pesquisar, target = null, filtrodescricao } = this.props;
        if (_.isNull(_AConditions)) {
            _AConditions = { "AND": [{ "campo": filtrodescricao, "operador": "LIKE", "valor": "" }], "OR": [] };
        }
        pesquisar(_AConditions, target, 1, this.setLoading);
    };

    setLoading = (_AValue = false) => {
        this.setState(_.set({ ...this.state }, "loading", _AValue));
    };

    handleLookupRemove = (ev) => {
        ev.stopPropagation();
        if (this.props.campoid) {
            this.props.onChange([], this.props.campoid);
        }
        else {
            this.props.onChange([]);
        }
    };

    handleChangeLookup = (_AValue, ev) => {
        const { selected = [], campoid = null, onChange } = this.props;
        let AArray = [];
        if (ev.action === "remove-value") {
            selected.forEach(item => {
                if (item.id !== ev.removedValue.id) {
                    AArray.push(item);
                }
            });
            onChange(AArray, campoid);
        }
        else if (ev.action === "select-option") {
            onChange(_AValue, campoid);
        }

    };

    getOptions = () => {
        let AResponse = [];
        const { options = [], campoid, camponome } = this.props;
        options.forEach(item => {
            AResponse.push({ ...item, value: item[campoid], label: item[camponome] });
        });
        return AResponse;
    };

    getSelected = () => {
        let AResponse = [];
        const { selected = [], campoid, camponome } = this.props;
        selected.forEach(item => {
            AResponse.push({ ...item, value: item[campoid], label: item[camponome] });
        });
        return AResponse;
    };

    render() {
        const { classes, className, selected = [], multiSelect = false, readOnly = false, label, novo = null, required, id, listagem = null, campoid, camponome, openDialog } = this.props;
        const form = this.state;
        return (
            <React.Fragment>
                <div
                    id="lookup"
                    className={clsx(className, classes.formGroup, "flex flex-row rounded-6 w-full")}
                >
                    {label &&
                        <Typography className={classes.formGroupTitle} color="textSecondary">{label + (required ? " *" : "")}</Typography>
                    }
                    <FormControl component="span" className={classes.formControl} key={id + "_Paper"} name={id + "_Paper"}>
                        <div className={"flex flex-row pl-8 items-start min-h-56"}>
                            <FuseChipSelect
                                className={clsx(classes.chipSelect, "w-full pt-12")}
                                variant="fixed"
                                // value={selected}
                                value={this.getSelected()}
                                isMulti
                                isDisabled={readOnly}
                                onChange={this.handleChangeLookup}
                                placeholder=""
                                closeMenuOnSelect
                                options={this.getOptions()}
                                noOptionsMessage={() => "Sem resultados"}
                                classes={{
                                    valueContainer: "p-0"
                                }}
                                textFieldProps={{
                                    onChange: ev => this.setState(_.set({ ...this.state }, "search", ev.target.value)),
                                    onBlur: () => this.setState(_.set({ ...this.state }, "search", "")),
                                    value: form.search,
                                    InputLabelProps: {
                                        shrink: true
                                    },
                                    classes: { root: classes.chipSelect }
                                }}
                            />
                            {form.loading ?
                                <div className="flex h-56 items-center">
                                    <CircularProgress size={"20px"} className="mr-12" />
                                </div>
                                :
                                <div className="flex h-56 items-center">
                                    {!readOnly && (form.search !== "" || selected.length !== 0) &&
                                        <Divider className={clsx(classes.divider)} />
                                    }

                                    {!readOnly && selected.length === 0 && !_.isNull(novo) &&
                                        <IconButton
                                            className={clsx(classes.iconButton)}
                                            aria-label="Novo"
                                            onClick={() => novo()}
                                            key={id + "_Novo"}
                                        >
                                            <MdAdd />
                                        </IconButton>
                                    }
                                    {!readOnly && selected.length !== 0 &&
                                        <IconButton
                                            className={clsx(classes.iconButton)}
                                            aria-label="Excluir"
                                            onClick={this.handleLookupRemove}
                                            key={id + "_Excluir"}
                                        >
                                            <MdClose />
                                        </IconButton>
                                    }

                                    {!readOnly && !_.isNull(listagem) &&
                                        <React.Fragment>
                                            <Divider className={clsx(classes.divider)} />
                                            <IconButton
                                                id="LookupIconSearch"
                                                className={classes.iconButton}
                                                aria-label="Pesquisar"
                                                onClick={() => openDialog(id + "_LookupDialog")}
                                                key={id + "_Pesquisar"}
                                            >
                                                <MdSearch />
                                            </IconButton>
                                        </React.Fragment>
                                    }
                                </div>
                            }
                        </div>
                    </FormControl>
                </div>
                <LookupDialog
                    LookupApp={this}
                    key={id + "_LookupDialog"}
                    id={id + "_LookupDialog"}
                    campoid={campoid}
                    camponome={camponome}
                    onChange={this.handleChangeLookup}
                    multiSelect={multiSelect}
                    selected={selected}
                    listagem={listagem}
                />
            </React.Fragment>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        openDialog: Actions.openDialog
    }, dispatch);
}

function mapStateToProps({ LookupApp }) {
    return {
        Lookup: LookupApp,
    };
}

export default withReducer("LookupApp", LookupReducer)(withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(LookupApp))));
